module.exports = __webpack_public_path__ + "img/app-store.e32514d4.webp";